import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useHead } from '@unhead/vue'

import { onMounted, onServerPrefetch, watch } from 'vue'

import ErrorContent from '@/components_new/ErrorContent/ErrorContent.vue'
import { useLocalizedRouters } from '@/composables/localized-routers'
import { useI18nAddon } from '@/i18n/i18n'
import Layout from '@/layouts/ModernLayout.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { type ErrorStatus } from '@/store/app-store'
import { useGeneralStore } from '@/store/general-store'


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  props: {
    type: {}
  },
  setup(__props: any) {

const generalStore = useGeneralStore()



const { getHrefLangs } = useLocalizedRouters()

useHead(() => ({
    link: getHrefLangs({ forRoute: { name: ROUTE_NAMES.MAIN } }),
}))

onServerPrefetch(async () => {
    await generalStore.setMainData()
})

onMounted(async () => {
    await generalStore.setMainData()
})

const { currentLocale } = useI18nAddon()
watch(currentLocale, generalStore.setMainData)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, null, {
    default: _withCtx(() => [
      _createVNode(ErrorContent, {
        type: _ctx.type,
        showButtons: ""
      }, null, 8, ["type"])
    ]),
    _: 1
  }))
}
}

})